/**
 * 检查元素a包围盒是否在元素b中
 * @param {*} elA
 * @param {*} elB
 * @returns {boolean}
 */
export function isInElementBox (elA, elB) {
  const elABox = elA.getBoundingClientRect()
  const elBBox = elB.getBoundingClientRect()

  if (
    elABox.top + elABox.height > elBBox.bottom ||
    elABox.bottom < elBBox.top ||
    elABox.left + elABox.width > elBBox.right ||
    elABox.right < elBBox.left
  ) {
    return false
  }

  return true
}
